/* eslint-disable react/no-danger */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/prop-types */
const MagnetAttribute: React.FC<{ pText: string; sText: string; additionalClasses?: string }> = ({
  pText,
  sText,
  additionalClasses = "",
}) => (
  <div className={`flex w-full flex-col justify-between font-satoshi font-semibold ${additionalClasses}`}>
    <p className="mb-1 text-white" dangerouslySetInnerHTML={{ __html: pText }} />
    <p className="font-satoshi  text-secondary">{sText}</p>
  </div>
);
export default MagnetAttribute;
